import { generateMutation, generateSubscription } from "Methods/query"
import { useMutation, useSubscription } from "@apollo/react-hooks"
import request from "Methods/request"

const tableName = "preset"
const subscription = generateSubscription(
    tableName,
    `
        article_type { color_code }
        creator_info { nickname, department { color, name } }
        author { name user_public { nickname department { name } } }
    `,
)
const insertMutation = generateMutation("insert", tableName, [
    { type: "Int", name: "seq_id" },
    { type: "Int", name: "author_id" },
    { type: "Int", name: "article_type_id" },
    { type: "String", name: "description" },
    { type: "Int", name: "ad_weekday" },
    { type: "Int", name: "channel_id" },
    { type: "String", name: "creator_id" },
])
const updateMutation = generateMutation("update", tableName, [
    { type: "Int", name: "id" },
    { type: "Int", name: "seq_id" },
    { type: "Int", name: "author_id" },
    { type: "Int", name: "article_type_id" },
    { type: "String", name: "description" },
    { type: "Int", name: "ad_weekday" },
    { type: "Int", name: "channel_id" },
    { type: "String", name: "creator_id" },
])
const deleteMutation = generateMutation("delete", tableName, [
    { type: "Int", name: "id" },
])
export function useSubscriptionPreset() {
    const { data } = useSubscription(subscription, { variables: { where: {} }})
    const { preset = [] } = data || {}
    return { preset }
}
export function usePresetHasura() {
    const [ createPreset ] = useMutation(insertMutation)
    const [ updatePreset ] = useMutation(updateMutation)
    const [ deletePreset ] = useMutation(deleteMutation)
    return { createPreset, updatePreset, deletePreset }
}
export interface ApplyData {
    start_at: Date,
    end_at: Date,
}
export function useApplyPreest() {
    const apply = async (data: ApplyData) => {
        try {
            await request.post("/apis/presets/apply", data)
        } catch (e) {
            throw e
        }
    }
    return { apply }
}

